import { render, staticRenderFns } from "./AdminUserProfileAdditional.vue?vue&type=template&id=05f43030"
import script from "./AdminUserProfileAdditional.vue?vue&type=script&lang=js"
export * from "./AdminUserProfileAdditional.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports